import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Table, TableBody } from '@mui/material';
import PropTypes from 'prop-types';

import { LoanConditionInfoTableTestIds } from './LoanConditionInfoTable.testIds';
import { formatSlaGroupLevels } from './LoanConditionInfoTable.utils';
import LoanConditionInfoTableHead from './LoanConditionInfoTableHead';
import LoanConditionInfoTableItem from './LoanConditionInfoTableItem';

const tableStyles = {
  boxShadow: ({ shadows }) => shadows[3],
  '& th:nth-child(1)': {
    width: '15%',
  },
  '& th:nth-child(2)': {
    width: '10%',
  },
  '& th:nth-child(3)': {
    width: '25%',
  },
  '& th:nth-child(4)': {
    width: '25%',
  },
  '& th:nth-child(5)': {
    width: '10%',
  },
  '& th:nth-child(6)': {
    width: '15%',
  },
  tableLayout: 'fixed',
};

const LoanConditionInfoTable = ({ loanConditionId, loanConditionByIdSelector }) => {
  const loanCondition = useSelector(loanConditionByIdSelector(loanConditionId));
  //select from store to trigger render on real time updates

  const slaLevels = useMemo(() => formatSlaGroupLevels(loanCondition?.slaGroup), [loanCondition]);

  return (
    <Table
      stickyHeader
      data-testid={LoanConditionInfoTableTestIds.LOAN_CONDITION_SLA_GROUP_TABLE}
      sx={tableStyles}
    >
      <LoanConditionInfoTableHead />
      <TableBody>
        {slaLevels.map(slaLevel => (
          <LoanConditionInfoTableItem key={slaLevel.loanConditionSlaLevelId} slaLevel={slaLevel} />
        ))}
      </TableBody>
    </Table>
  );
};

LoanConditionInfoTable.propTypes = {
  loanConditionId: PropTypes.string.isRequired,
  loanConditionByIdSelector: PropTypes.func.isRequired,
};

export default memo(LoanConditionInfoTable);
